module.exports = __webpack_public_path__ + "img/DE02627.d84dd7b2.png";